module.exports = __webpack_public_path__ + "static/media/logo.f342226d.svg";